
import React from 'react';

const translations = {
  ar: {
    title: "لماذا رفاد التدوير؟",
    sub: "تميزنا وقدراتنا التشغيلية",
    features: [
      { icon: "fas fa-handshake", title: "سد الفجوات المحلية", desc: "نحن نجسر الفجوة بين العمل الميداني الشاق وبين الاستعادة الدقيقة للأصول، لضمان التعامل مع كل مكون باحترافية فنية كاملة" },
      { icon: "fas fa-chart-line", title: "المرونة التشغيلية", desc: "قدرة مثبتة على العمل في المواقع النائية والظروف الجغرافية القاسية" },
      { icon: "fas fa-tools", title: "النزاهة الفنية", desc: "استخدام أدوات متخصصة وخبرات ميدانية لضمان تفكيك خالٍ من المخاطر" },
      { icon: "fas fa-recycle", title: "الاستدامة الاقتصادية", desc: "التزام بتقليل الأثر البيئي في المناطق الصناعية عبر استكمال دورة حياة الأجهزة وتحويلها لموارد اقتصادية" },
      { icon: "fas fa-warehouse", title: "إدارة المساحات", desc: "مساعدة العميل في التخلص من المواد الفائضة لتوفير مساحات التخزين وتقليل تكاليف المساحات المهدرة" },
      { icon: "fas fa-truck-moving", title: "خدمات الإمداد والنقل عالية السعة", desc: "عمليات نقل ميدانية ضخمة ومسح شامل للمواقع بأنسب المعدات" },
      { icon: "fas fa-microchip", title: "الفرز الدقيق", desc: "تصنيف متطور للإلكترونيات والأصول التخصصية" },
      { icon: "fas fa-hard-hat", title: "التفكيك الميداني", desc: "تنفيذ فعلي لتفكيك الأجهزة التقنية المعقدة بالمناطق الحساسة والأبراج والمعدات الثقيلة في موقع العميل مباشرة" }
    ]
  },
  en: {
    title: "Why Rafad Recycling?",
    sub: "Operational Capabilities",
    features: [
      { icon: "fas fa-handshake", title: "Bridging Local Gaps", desc: "We bridge the gap between heavy field labor and delicate asset recovery, ensuring every component is handled with full technical proficiency" },
      { icon: "fas fa-chart-line", title: "Operational Resilience", desc: "Proven ability to operate in remote locations and harsh geographical conditions" },
      { icon: "fas fa-tools", title: "Technical Integrity", desc: "Utilizing specialized tools and field expertise to ensure risk-free decommissioning" },
      { icon: "fas fa-recycle", title: "Economic Sustainability", desc: "A commitment to reducing environmental impact in industrial zones by completing the equipment life cycle and transforming it into economic resources" },
      { icon: "fas fa-warehouse", title: "Space Management", desc: "Assisting clients in disposing of surplus materials to free up storage space and reduce wasted area costs" },
      { icon: "fas fa-truck-moving", title: "High-Capacity Supply & Transport Services", desc: "Massive field transport operations and comprehensive site surveys using the most suitable equipment" },
      { icon: "fas fa-microchip", title: "Precision Sorting", desc: "Advanced categorization of electronics and specialized assets" },
      { icon: "fas fa-hard-hat", title: "On-Site Dismantling", desc: "Real-world execution of dismantling complex technical devices in sensitive areas, standing towers, and heavy equipment directly at the client's site" }
    ]
  }
};

const Features = ({ currentLang }) => {
  const t = translations[currentLang];

  return (
    <section id="features" style={{ position: 'relative', zIndex: 1 }}>
      <h2 className="section-title">{t.title}</h2>
      <p className="section-sub">{t.sub}</p>
      
      <div className="features-grid">
        {t.features.map((feature, index) => (
          <div className="feature-item" key={index}>
            <i className={feature.icon}></i>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </div>
        ))}
      </div>
      
      <style>{`
        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 2rem;
          margin-top: 3rem;
          max-width: 1400px;
          margin-left: auto;
          margin-right: auto;
          padding: 0 1.5rem;
        }
        
        .feature-item {
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          border-radius: 28px;
          padding: 2rem 1.8rem;
          text-align: center;
          transition: all 0.4s ease;
          border: 1px solid rgba(83, 176, 150, 0.2);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.03);
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .feature-item:hover {
          transform: translateY(-8px);
          border-color: rgba(83, 176, 150, 0.5);
          background: rgba(255, 255, 255, 0.95);
          box-shadow: 0 15px 35px rgba(83, 176, 150, 0.1);
        }
        
        .feature-item i {
          font-size: 2.8rem;
          color: #53b096;
          margin-bottom: 1.2rem;
        }
        
        .feature-item h3 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1a2a3a;
          margin-bottom: 0.8rem;
        }
        
        .feature-item p {
          color: #5a6a7a;
          line-height: 1.5;
          flex-grow: 1;
        }
        
        /* responsive breakpoints */
        @media (min-width: 1024px) {
          .features-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }
        
        @media (min-width: 768px) and (max-width: 1023px) {
          .features-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (max-width: 767px) {
          .features-grid {
            grid-template-columns: 1fr;
            padding: 0 1rem;
          }
          
          .feature-item {
            max-width: 400px;
            margin: 0 auto;
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default Features;